

import React, { useState } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import Button from '../buttons/button';
import { useUnassignSurveyMutation } from '../../../app/surveyApi/surveyApi';
import { showToast } from '../../../helpers/Utils';

const UnassignSurveyModal = ({ show, setShow, surveyId, userId,leadId}) => {
    
    
const [unassignSurvey,isLoading] = useUnassignSurveyMutation();

 const handleUnassign = async () => {
  try {
    await unassignSurvey({
      surveyId: surveyId,
      userId: userId,
      leadId
    }).unwrap();
    showToast("Survey unassigned successfully", "success");
    setShow(false)
  } catch (error) {
    showToast("Failed to unassign survey", "error");
  }
};

  return (
    <CommonModal show={show} setShow={setShow} title="Delete Survey" className={'width-md'}>
      <h3 className="delete-survey text-center mb-4">
        Are you sure you want to unassign this survey?
      </h3>
      <div className="d-flex gap-3 justify-content-center">
        <Button label="Cancel" className={'borderedBtn'} onClick={() => setShow(false)} />
        <Button label="Confirm" onClick={handleUnassign} disabled={isLoading} />
      </div>
    </CommonModal>
  );
};

export default UnassignSurveyModal;